import useUI from 'src/hooks/use-ui';
import { useDutchiePay } from 'src/payments/hooks/use-dutchie-pay/use-dutchie-pay';
import { useCashBackSurfaceGate } from 'src/payments/hooks/use-cash-back-surface-gate';
import type { ValidIncentiveValue } from 'src/payments/hooks/shared/incentive-types';

// The gate owns eligibility/flag/discount-precedence suppression; the footer additionally
// suppresses where Pay by Bank can't be offered (kiosk, dispensary/order type without PBB).
export const useCartCashBackTreatment = (): {
  showTreatment: boolean;
  cashBackValue: ValidIncentiveValue | undefined;
} => {
  const { isKiosk } = useUI();
  const { isDutchiePayEnabledForDispo } = useDutchiePay();
  const { showCashBack, cashBackValue } = useCashBackSurfaceGate('cart');

  const showTreatment = showCashBack && cashBackValue !== undefined && !isKiosk && isDutchiePayEnabledForDispo;

  return { showTreatment, cashBackValue: showTreatment ? cashBackValue : undefined };
};
